var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlay = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.26404 0.352788C1.83788 -0.474645 0.681641 0.203198 0.681641 1.86558V14.1332C0.681641 15.7973 1.83788 16.4743 3.26404 15.6476L13.8652 9.4983C15.2919 8.67057 15.2919 7.32953 13.8652 6.502L3.26404 0.352788Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlay, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play.118b4f06.svg";
export { ForwardRef as ReactComponent };